// extracted by mini-css-extract-plugin
export default {"title":"AvailableProducts_title__Z-Cws","content":"AvailableProducts_content__F4Fx7"};